import React from 'react';
import PropTypes from 'prop-types';
type TokenInputProps = {
  validationClass: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  minLength?: number;
  maxLength?: number;
};
export function TokenInput(props: TokenInputProps) {
  const { validationClass, value, onChange, minLength, maxLength } = props;
  return (
    <div className="form-group col">
      <label htmlFor="token" className="col-form-label">
        Token
      </label>
      <input
        type="text"
        name="token"
        className={`form-control ${validationClass}`}
        value={value}
        id="token"
        onChange={onChange}
        required
        placeholder="Your token"
        minLength={minLength}
        maxLength={maxLength}
      />
    </div>
  );
}
TokenInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  validationClass: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
